import { Injectable } from '@angular/core';
import { FeatureTogglesClient } from '@purecloud/feature-toggles-client';
import { firstValueFrom } from 'rxjs';
import { GenesysCloudConfigService } from 'common/genesys-cloud-config';

@Injectable({
  providedIn: 'root'
})
export class FeatureTogglesClientFactory {
  constructor(private genesysCloudConfigService: GenesysCloudConfigService) {
  }

  async createFeatureTogglesClient(): Promise<FeatureTogglesClient> {
    const config = await firstValueFrom(this.genesysCloudConfigService.apiConfig$);
    return new FeatureTogglesClient({
      accessToken: config.accessToken,
      baseUrl: config.apiEndpoints.apiUri
    });
  }
}
